export interface ShapeDefaults {
    rect: RectShape,
    symbol: SymbolShape,
    line: LineShape,
    circle: CircleShape,
    text: TextShape,
    polygon: PolygonShape,
}
const MatrixStart: Mat5 = [
    [1, 0, 0, 0],
    [0, 1, 0, 0],
    [0, 0, 1, 0],
    [0, 0, 0, 1]]
export const startingLayerList: Layer[] = [{ id: 0, name: "Default", visibility: true }, { id: 1, name: "Test_01", visibility: true }]

export const editingDefaults: {
    line: LineShape,
} = {
    line: {
        layerId: 0,
        type: "line",
        hitStrokeWidth: 0,
        closed: false,
        points: [],
        dashID: 0,
        dashEnabled: false,
        id: 0,
        stroke: "rgb(200 ,200,200 )",
        draggable: false,
        strokeWidth: 2,
        transformation: MatrixStart,
        mirrored: false,
        width: 0,
        height: 0,
        boundingboxPosition: { x: 0, y: 0 }
    },
}
export const shapeDefaults: ShapeDefaults = {
    circle: {
        layerId: 0,
        type: "circle",
        id: 0,
        x: 0,
        y: 0,
        radius: 0,
        clockwise: false,
        startAngle: 0,
        endAngle: 2 * Math.PI,
        fill: "rgb(150, 150, 150)",
        stroke: 'rgb(10,88,100)',
        fillEnabled: false,
        strokeWidth: 3,
        strokeEnabled: true,
        draggable: true,
        transformation: MatrixStart,
        mirrored: false,
        hitStrokeWidth: 3,
        width: 0,
        height: 0,
        boundingboxPosition: { x: 0, y: 0 }
    },
    text: {
        layerId: 0,
        type: "text",
        id: 0,
        uiText: "<Text>",
        fontType: "Arial",
        fontStyle: "",
        fontSize: 20,
        align: "center",
        rotation: 0,
        stroke: "#555",
        draggable: true,
        strokeWidth: 0,
        x: 0,
        y: 0,
        rot: 0,
        lineColor: "rgb(50,50,200)",
        transformation: MatrixStart,
        mirrored: false,
        height: 0,
        width: 0,
        fill: "#000000",
        boundingboxPosition: { x: 0, y: 0 }
    },
    rect: {
        layerId: 0,
        type: "rect",
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        id: 0,
        stroke: "",
        draggable: false,
        strokeWidth: undefined,
        transformation: [],
        mirrored: false,
        boundingboxPosition: { x: 0, y: 0 }
    },

    symbol: {
        type: "symbol",
        x: 0,
        y: 0,
        rot: 0,
        scale: 1,
        imageKey: "",
        layerId: 0,
        id: 0,
        stroke: 'rgb(10,88,100)',
        draggable: false,
        strokeWidth: undefined,
        transformation: MatrixStart,
        width: 0,
        height: 0,
        mirrored: false,
        boundingboxPosition: { x: 0, y: 0 },
        anchor: { horizontal: "left", vertical: "top" }
    },
    line: {
        layerId: 0,
        type: "line",
        id: 0,
        strokeWidth: 3,
        stroke: 'rgb(10,88,100)',
        draggable: true,
        hitStrokeWidth: 3,
        dashEnabled: true,
        closed: false,
        points: [],
        transformation: MatrixStart,
        mirrored: false,
        dashID: 0,
        width: 0,
        height: 0,
        boundingboxPosition: { x: 0, y: 0 }
    },
    polygon: {
        type: "polygon",
        fillEnabled: false,
        fill: undefined,
        hitStrokeWidth: 0,
        closed: false,
        points: [],
        dashID: 0,
        layerId: 0,
        id: 0,
        stroke: 'rgb(10,88,100)',
        draggable: false,
        strokeWidth: undefined,
        transformation: MatrixStart,
        width: 0,
        height: 0,
        mirrored: false,
        boundingboxPosition: { x: 0, y: 0 }
    },
}